export const UnitKey = {
  ADD_UNIT: { name: 'ADD UNIT', sequence: 'alt+a' }
}
export const UnitHandle = ({ addUnit }) => ({
  ADD_UNIT: () => addUnit()
})
